import { useLayoutEffect, useRef } from "react";
import { activateFocusTrap } from "./focusTrap";

/**
 * React hook: trap focus while `enabled` is true.
 *
 * @param {object} options
 * @param {boolean} options.enabled
 * @param {React.RefObject<HTMLElement | null>} options.containerRef
 * @param {() => void} [options.onEscape]
 * @param {boolean} [options.restoreFocus=true]
 * @param {boolean} [options.initialFocus=true]
 */
export function useFocusTrap({
  enabled,
  containerRef,
  onEscape,
  restoreFocus = true,
  initialFocus = true,
}) {
  const onEscapeRef = useRef(onEscape);
  onEscapeRef.current = onEscape;

  useLayoutEffect(() => {
    return activateFocusTrap({
      enabled,
      containerRef,
      onEscape: () => onEscapeRef.current?.(),
      restoreFocus,
      initialFocus,
    });
  }, [enabled, containerRef, restoreFocus, initialFocus]);
}
